import React, { useEffect,useState } from 'react'
import './BlockSts.css'
import {useAuth} from './AuthContext'
import app from './firebase'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { fa-inr } from '@fortawesome/free-svg-core'

const BlockSts = (props) => {
    const [total,setTotal]=useState({})
    const {currentUser}=useAuth()
    var [c,setChk]=useState(false)
    //var [sum,setSum]=useState([])
    /*function sllep(time){
        return new Promise((resolve)=>setTimeout(resolve,time));
    }
    async function incr(){
        var v=0
            while(v<80){
                document.getElementById("stsInc").style.width=v+"px"
                await sllep(600)
                v=v+5
                if(v>80){
                    break
                }
            }
    }*/
    useEffect(
        () => {
            //incr() 

            var r = document.querySelector(":root")
            if (props.A === "anim") {
                if(parseInt( (props.incr).split('px')[0])<=100){r.style.setProperty('--SS', props.incr)
            console.log('in 1')}
                if(parseInt( (props.incr).split('px')[0])>100 || parseInt( (props.incr).split('px')[0])<=300){r.style.setProperty('--SS', (parseInt( (props.incr).split('px')[0])-200)+"px")
            console.log("in 2")}
                console.log(props.incr)
            }
            if (props.A === "ani") {
                r.style.setProperty('--SSS', props.incr)
            }
            if (props.A == "an") {
                r.style.setProperty('--SSSS', props.incr)
            }
            /*r.style.setProperty('--SS',props.incr)
            console.log(props.incr)
            r.style.setProperty('--SSS',props.incr)
            console.log(props.incr)
            r.style.setProperty('--SSSS',props.incr)
            console.log(props.incr)*/


        }
    )

    useEffect(() => {
        var g = (currentUser.email).split(".")
        app.child(g[0]).on("value",(snapshot)=>{
          if(snapshot.val()){
              setTotal({
                ...snapshot.val()
              })
              
          }
      })
      }, [])


    return (
        <div id="conttt">
            <div id="Day"><h4>{props.dwy}</h4></div>
            <div id="stsInCont" >
                <div id="stsInc" style={{ animation: `${props.A} ${props.time} linear`, width: `${props.incr}` }} ></div>
            </div>
            <p>
               {'\u20B9'}
               {props.Rupee}
            </p>

        </div>
    )
}


export default BlockSts